import {
  DocumentDetailResponse,
  DocumentLanguage,
  DocumentParams,
  EditDocumentData,
  GetDocumentForFlexWorkerResponse,
  GetDocumentsResponse,
  IssueDocumentData,
  RenderDocumentResponse,
  SignDocumentDtoRequest,
} from './documents-service.types';
import { HqApiService } from './hqApiService';

class DocumentsService {
  constructor(private readonly hqApiService: HqApiService) {}

  public async getDocuments({
    pageParam,
    pageSizeParam,
    status,
    documentType,
    name,
  }: DocumentParams): Promise<GetDocumentsResponse> {
    const response = await this.hqApiService.get<GetDocumentsResponse>({
      path: 'documents/all',
      params: {
        page: pageParam,
        pageSize: pageSizeParam,
        status,
        documentType,
        name,
      },
    });
    return response;
  }

  public async renderDocument(documentId: string): Promise<RenderDocumentResponse> {
    const response = await this.hqApiService.get<RenderDocumentResponse>({
      path: `documents/render/${documentId}`,
    });
    return response;
  }

  public async issueDocument(formData: IssueDocumentData): Promise<void> {
    await this.hqApiService.create<void>({
      body: formData,
      path: `documents/${formData.workerId}/issue`,
    });
  }

  public async editDocument(formData: EditDocumentData): Promise<void> {
    await this.hqApiService.update<void>({
      body: formData,
      path: `documents/${formData.documentId}/edit`,
    });
  }

  public async findDocumentForFlexWorker(
    flexWorkerId: string,
    documentType: string
  ): Promise<GetDocumentForFlexWorkerResponse | null> {
    const response = await this.hqApiService.get<GetDocumentForFlexWorkerResponse | null>({
      path: `documents/${flexWorkerId}/${documentType}`,
    });
    return response;
  }

  public async getDocumentDetailById(documentId: string) {
    const response = await this.hqApiService.get<DocumentDetailResponse>({
      path: `documents/${documentId}`,
    });
    return response;
  }

  public async signDocument(
    documentId: string,
    dynamicProperties: SignDocumentDtoRequest,
    contractMinutes: number,
    workerId: string
  ): Promise<void> {
    await this.hqApiService.update<void>({
      path: `documents/${documentId}/sign`,
      body: {
        dynamicProperties,
        contractMinutes,
        workerId,
      },
    });
  }

  public async editDocumentLanguage(documentId: string, language: DocumentLanguage): Promise<void> {
    await this.hqApiService.update<void>({
      body: { language },
      path: `documents/${documentId}/language`,
    });
  }
}
export { DocumentsService };
